import { ContasReceberCopiaForm } from "../../../presentation/schemas/ContasReceber_lista/ContasReceber_copia";
import { ICopiaContasReceberUseCase } from "../../../presentation/useCases/create/copia_contas_receber_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CopiaContasReceberUseCase
 */

export class CopiaContasReceberUseCase implements ICopiaContasReceberUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async copiaContasReceber(form: ContasReceberCopiaForm): Promise<void> {
    await this.repository.copiaContasReceber(form);

  }
}


